"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUipArrays = exports.getDataFromUipResponse = void 0;
const parseUipArrays = uipArray => {
  const parsedArray = uipArray.map(x => JSON.parse(x)).filter(object => object.product === 'domain').map(object => object.name);
  return Array.from(new Set(parsedArray.reverse()));
};
exports.parseUipArrays = parseUipArrays;
const getDataFromUipResponse = (uipData = {}) => {
  const uipSearchHistoryArray = uipData.data.user.godaddy.marketing.search_history_array;
  const uipFavProductArray = uipData.data.user.godaddy.marketing.favorite_product_array;
  const searchHistoryNoDups = parseUipArrays(uipSearchHistoryArray);
  const favoritesMostRecentFirst = parseUipArrays(uipFavProductArray);
  const favoritesParsedUipData = uipFavProductArray.map(x => JSON.parse(x));
  return {
    favoritesList: favoritesMostRecentFirst,
    historyList: searchHistoryNoDups,
    favoritesParsedUipData
  };
};
exports.getDataFromUipResponse = getDataFromUipResponse;